import React from 'react'
import { Icon, Card } from '../../../atoms'
import { connect } from 'react-redux'
import { brand } from '../../../redux/app-selectors'

interface IListItemsDetails {
  title: string
  prosTitle: string
  consTitle: string
  prosList: Array<string>
  consList: Array<string>
}

interface ProsConsCardProps {
  name: string
  jsonBody: IListItemsDetails
  showHeader: boolean
  brand: 'money' | 'uswitch' | 'confused'
}

const ProsConsCard = ({ jsonBody, name, showHeader, brand }: ProsConsCardProps) => {
  const { title, prosTitle, consTitle, prosList, consList } = jsonBody

  try {
    return (
      <div className='pros-cons' id={name}>
        {showHeader && <h2 className='pros-cons__heading'>{title}</h2>}
        <div className='pros-cons__container'>
          <Card variant='modal' className={brand === 'confused' ? 'pros-cons__card' : ''}>
            <div className='pros-cons__container__box'>
              {prosTitle && brand === 'confused' ? (
                <div className='pros-cons__container__box__title'>
                  <h2 className='pros-cons__container__box__text'>{prosTitle}</h2>
                </div>
              ) : (
                prosTitle && <h3 className='pros-cons__container__box__text'>{prosTitle}</h3>
              )}
              <div className='pros-cons__container__box__list'>
                {prosList.map((ele, i) => (
                  <div key={i} className='pros-cons__container__box__list__container'>
                    <div>
                      <Icon
                        glyph={'tick-circle'}
                        size={brand === 'confused' ? 45 : 26}
                        color={brand === 'money' ? '#924A8B' : '#141414'}
                      />
                    </div>
                    <span className='pros-cons__container__box__list__text'>{ele}</span>
                  </div>
                ))}
              </div>
            </div>
          </Card>
          <Card variant='modal' className={brand === 'confused' ? 'pros-cons__card' : ''}>
            <div className='pros-cons__container__box'>
              {consTitle && brand === 'confused' ? (
                <div className='pros-cons__container__box__title'>
                  <h2 className='pros-cons__container__box__text'>{consTitle}</h2>
                </div>
              ) : (
                consTitle && <h3 className='pros-cons__container__box__text'>{consTitle}</h3>
              )}
              <div className='pros-cons__container__box__list'>
                {consList.map((ele, i) => (
                  <div key={i} className='pros-cons__container__box__list__container'>
                    <div>
                      <Icon
                        glyph={'cross-circle'}
                        size={brand === 'confused' ? 45 : 26}
                        color={brand === 'money' ? '#924A8B' : '#141414'}
                      />
                    </div>
                    <span className='pros-cons__container__box__list__text'>{ele}</span>
                  </div>
                ))}
              </div>
            </div>
          </Card>
        </div>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default connect((state, props) => {
  return {
    brand: brand(state),
    ...props,
  }
})(ProsConsCard)
